import { Component, HostListener, inject, output, signal, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@digitalware-rs/dw-components';
import { AuthService } from '../../auth/auth.service';
import { ThemeService } from '../../theme/theme.service';
import { LANGUAGES, LanguageService } from '../../language/language.service';
import { PageTitleService } from '../../navigation/page-title.service';

@Component({
  selector: 'app-header',
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatTooltipModule,
    MatMenuModule,
    TranslateModule,
    IconComponent,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  private readonly auth   = inject(AuthService);
  private readonly router = inject(Router);
  protected theme = inject(ThemeService);
  protected language = inject(LanguageService);
  protected pageTitle = inject(PageTitleService);
  protected languages = LANGUAGES;

  menuClick = output<void>();

  protected isLoggedIn = signal(false);
  protected username = signal('');
  protected email = signal('');
  protected initials = signal('');
  protected userMenuOpen = signal(false);
  protected langMenuOpen = signal(false);

  @HostListener('document:click')
  onDocumentClick(): void {
    this.userMenuOpen.set(false);
    this.langMenuOpen.set(false);
  }

  ngOnInit(): void {
    this.isLoggedIn.set(this.auth.isLoggedIn());
    if (this.auth.isLoggedIn()) {
      this.auth.getUserProfile().then(profile => {
        const first = profile.firstName ?? '';
        const last = profile.lastName ?? '';
        this.username.set([first, last].filter(Boolean).join(' ') || profile.username || profile.email || '');
        this.email.set(profile.email ?? '');
        const i = (first[0] ?? '') + (last[0] ?? '');
        this.initials.set(i.toUpperCase() || (profile.username?.[0] ?? '').toUpperCase());
      });
    }
  }

  protected toggleUserMenu(event: MouseEvent): void {
    event.stopPropagation();
    this.langMenuOpen.set(false);
    this.userMenuOpen.update(v => !v);
  }

  protected toggleLangMenu(event: MouseEvent): void {
    event.stopPropagation();
    this.userMenuOpen.set(false);
    this.langMenuOpen.update(v => !v);
  }

  protected login(): void {
    this.auth.login();
  }

  protected logout(): void {
    this.auth.logout();
  }

  protected navigateToProfile(): void {
    this.userMenuOpen.set(false);
    this.router.navigate(['/profile']);
  }
}
